import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useAdminWordDelete } from "@/hooks/useAdminWordDelete";

interface AdminDeleteWordButtonProps {
  word: string;
  onDeleted?: () => void;
}

export const AdminDeleteWordButton = ({ word, onDeleted }: AdminDeleteWordButtonProps) => {
  const [open, setOpen] = useState(false);
  const { deleteWord, isDeleting } = useAdminWordDelete();

  const handleDelete = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const success = await deleteWord(word);
    if (success) {
      setOpen(false);
      onDeleted?.();
    }
  };

  const handleTriggerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0 text-destructive hover:text-destructive hover:bg-destructive/10"
          onClick={handleTriggerClick}
          title="Ta bort ord"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Ta bort "{word}"?</AlertDialogTitle>
          <AlertDialogDescription>
            Detta kommer att permanent ta bort ordet och alla tillhörande ledtrådar från databasen. 
            Denna åtgärd kan inte ångras.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={(e) => e.stopPropagation()}>Avbryt</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Tar bort...
              </>
            ) : (
              "Ta bort"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
